import React, { useEffect, useState } from "react";
import { node } from "prop-types";

import useFeatureState from "../../utilities/hooks/useFeatureState";
import useReducerActions from "../../utilities/useReducerActions";
import * as S from "./styled";

const MultiStepQuestionnaire = ({ children }) => {
  const { questionnaireStepNumber = 0 } = useFeatureState();
  const {
    dispatchResetQuestionnaireStep,
    dispatchSetQuestionnaireTotalSteps
  } = useReducerActions();

  const steps = React.Children.toArray(children);
  const [step, setStep] = useState(steps[questionnaireStepNumber]);
  const totalSteps = steps.length;

  useEffect(() => {
    dispatchSetQuestionnaireTotalSteps(totalSteps);
  }, []);

  useEffect(() => {
    const nextStep = steps[questionnaireStepNumber];
    if (nextStep) {
      setStep(nextStep);
    } else {
      dispatchResetQuestionnaireStep();
    }
  }, [questionnaireStepNumber]);

  const renderDots = () => {
    if (totalSteps < 2) {
      return null;
    }

    const dots = [];
    for (let stepNumber = 0; stepNumber < totalSteps; stepNumber += 1) {
      dots.push(
        <S.Dot
          key={stepNumber}
          active={stepNumber === questionnaireStepNumber}
        />
      );
    }

    return <S.DotsContainer>{dots}</S.DotsContainer>;
  };

  return (
    Boolean(totalSteps) && (
      <>
        <S.QuestionContainer>{step}</S.QuestionContainer>
        <S.ErrorContainer id="questionnaire-error" />
        {renderDots()}
      </>
    )
  );
};

MultiStepQuestionnaire.propTypes = {
  children: node
};

MultiStepQuestionnaire.defaultProps = {
  children: null
};

export default MultiStepQuestionnaire;
